export enum VertragsStatus {
    INITIALISIERT = 10,
    STAMM_GEPRUEFT = 20,
    ENTWURF_GEDRUCKT = 30,
    GEPRUEFT = 40,
    EXTERN_PENDENT = 45,
    GEDRUCKT = 50,
    GEMAHNT = 70,
    UNTERSCHRIEBEN = 80,
    GUELTIG = 90,
    GESPERRT = 95,
    UNGUELTIG = 99,
}

export interface IEbankingVT {
    kdLnr: any; // TODO: evaluate the type of this property
    ktLnr: any; // TODO: evaluate the type of this property
    kontonummer: number;
    kontoart: number;
    iban: string;
    qrIban: string;
    userbank: number;
    eigenerZugriff: number;
    vtLnr: any; // TODO: evaluate the type of this property
    vtId: string;
    status: VertragsStatus;
    statusZeit: string;
    vorname: string;
    nachname: string;
    kundenbezeichnung: string;
    zv_auftr_ok: string;
    kt_buchungen_sichtbar: string;
    auftr_aus_ib_ok: string;
    auftr_visum_berechtigung: string;
    fuer_ib_verwendbar: string;
    salaerzahlung_sichtbar: string;
    limTagVis1: number;
    limTagVis2: number;
    limTag: number;
    limMtVis1: number;
    limMtVis2: number;
    limMt: number;
}
